import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3448b759"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "TGestaoTravamento",
  "data-testid": "TGestaoTravamento"
}
const _hoisted_2 = { class: "TGestaoTravamento__Cabecalho" }
const _hoisted_3 = { class: "TGestaoTravamento__Subtitulo" }
const _hoisted_4 = {
  id: "TGestaoTravamento__LegendaDaTabela",
  class: "TGestaoTravamento__LegendaDaTabela"
}
const _hoisted_5 = { class: "TGestaoTravamento__Botao" }
const _hoisted_6 = { class: "TGestaoTravamento__TabelaDestravarPeriodos" }

import { MenuItem } from "primevue/menuitem"
  import { ref, computed } from "vue"
  import {
    OTravarPeriodo,
  } from "@/components/Calendario"
  import { OTrilhaDeNavegacao } from "@/components/Gerais"
  import OTabelaDestravarPeriodo from "@/components/Atividades/OTabelaDestravarPeriodo/OTabelaDestravarPeriodo.vue"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  import { useI18n } from "vue-i18n"

  interface Props {
    rotaBase: MenuItem
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TGestaoTravamento',
  props: {
    rotaBase: null
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const permissionadorTravamento = usarPermissionamento("Travamento")

  const modalTravarAtividadeVisivel = ref(false)

  const temPermissaoParaTravarPeriodo = computed(() => {
    return (
      permissionadorTravamento.verificarPermissao("travar")
    )
  })

  const exibirModalDeTravamento = () => {
    modalTravarAtividadeVisivel.value = true
  }


return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(OTrilhaDeNavegacao), {
          "inicio-da-trilha": __props.rotaBase,
          "itens-da-trilha": []
        }, null, 8, ["inicio-da-trilha"]),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('selecionePrimeiroDiaDeDestravamento')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(temPermissaoParaTravarPeriodo))
          ? (_openBlock(), _createBlock(_component_PButton, {
              key: 0,
              onClick: exibirModalDeTravamento,
              class: "TGestaoTravamento__BotaoTravarPeriodo p-button-warning",
              label: _unref(t)('travarNovoPeriodo')
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(OTabelaDestravarPeriodo)
    ]),
    (modalTravarAtividadeVisivel.value)
      ? (_openBlock(), _createBlock(_unref(OTravarPeriodo), {
          key: 0,
          visible: modalTravarAtividadeVisivel.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((modalTravarAtividadeVisivel).value = $event)),
          "data-testid": "Atividades__TravarEvento"
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})